// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"c9ed9f7f","238":"3bc446e0","453":"2806c5d3"}[chunkId] + ".chunk.js";
};